import { nucleusConstants } from '@lifesize/nucleus';
import { remotingConstants } from '@lifesize/clients.remoting';
import * as intl from 'react-intl-universal';
import { get } from 'lodash';
import AppState from 'constants/Types/AppState';
import { createReducer } from '../redux-utils';
import ActionTypes from '../constants/ActionTypes';
import { PayloadAction } from '@lifesize/typescript-react-redux-utils';

export const initialState: AppState = {
  authenticationError: '',
  hasPresentationError: false,
  isExtensionInstallVisible: false,
  isWaitingForExtensionInstall: false,
  loggingId: '',
  uuid: '',
  isAuthenticating: false
};

export default createReducer(initialState, {
  [ActionTypes.AuthenticationEdit]: (state: AppState) => {
    return {
      ...state,
      authenticationError: '',
    };
  },
  [ActionTypes.LoginError]: (state: AppState) => {
    return {
      ...initialState,
      authenticationError: intl.get('authentication_failed')
    };
  },
  [ActionTypes.SubmitPresenterCode]: (state: AppState, action: any) => {
    // submit the presenter code to link the presenter to the dash room display
    return {
      ...state,
      ...action.payload,
      isAuthenticating: true
    };
  },
  [ActionTypes.StartPresenting]: (state: AppState, action: any) => {
    // set the selected source/stream id of the presentation
    return {
      ...state,
      hasPresentationError: false
    };
  },
  [nucleusConstants.INITIALIZE_SERVICES_SUCCESS]: (state: AppState) => {
    return {
      ...state,
      authenticationError: '',
      isAuthenticating: false
    };
  },
  [remotingConstants.pairing.actions.GET_PRESENTER_TOKEN_SUCCESS]: (state: AppState, action: any) => {
    /* the uuid of this presenter (included in this response) is added to the display's presenters array when the
     * linkedUUID is delivered to the display's ls.pairing subscription */
    return {
      ...state,
      authenticationError: '',
      uuid: get(action, 'payload.linkedUUID') || ''
    };
  },
  [remotingConstants.pairing.actions.GET_PRESENTER_TOKEN_FAILED]: (state: AppState, action: any) => {
    const payload = get(action, 'payload');
    const errorString = (payload && typeof payload !== 'string') ? payload.toString() : payload;
    // catch TypeError: Failed to fetch (ERR_INTERNET_DISCONNECTED)
    const authError = (errorString === 'TypeError: Failed to fetch') ? intl.get('authentication_network') : errorString;
    return {
      ...initialState,
      authenticationError: authError || intl.get('authentication_failed'),
      isAuthenticating: false
    };
  },
  [ActionTypes.EndExtensionInstall]: (state: AppState) => {
    return {
      ...state,
      isExtensionInstallVisible: false,
      isWaitingForExtensionInstall: false
    };
  },
  [ActionTypes.InstallExtension]: (state: AppState) => {
    return {
      ...state,
      isExtensionInstallVisible: true,
      isWaitingForExtensionInstall: false
    };
  },
  [ActionTypes.WaitForExtensionInstall]: (state: AppState) => {
    return {
      ...state,
      isWaitingForExtensionInstall: true
    };
  },
  [ActionTypes.SetPresentationError]: (state: AppState, action: any) => {
    return {
      ...state,
      hasPresentationError: get(action, 'payload')
    };
  },
  [ActionTypes.SetLoggingId]: (state: AppState, action: PayloadAction<ActionTypes, string>) => ({
    ...state,
    loggingId: action.payload
  })
});



// WEBPACK FOOTER //
// ./src/reducers/app.ts